import React, { useState, useEffect } from 'react';
import {
  genres,
  statuses,
  ratings,
  types,
  order_by,
} from '../../constants/queryParams';
import { useAnimeContext } from '../../contexts/animeContext';
import apiUrls from '../../constants/apiUrls';
import { useNavigate } from 'react-router-dom';
import Input from '../../UI/Input';

const Filter = () => {
  const { setUrl, url } = useAnimeContext();
  const navigate = useNavigate();

  const queryParamObj = {
    url: apiUrls.search,
    q: '',
    genres: '',
    status: '',
    rating: '',
    type: '',
    order_by: '',
    paramArr: ['q', 'genres', 'status', 'rating', 'type', 'order_by'],
    getUrl: function () {
      let finalurl = this.url;
      this.paramArr.forEach((param) => {
        if (this[param] !== '') {
          finalurl += `&${param}=${this[param]}`;
        }
      });
      return finalurl;
    },
  };

  const [queryParams, setQueryParams] = useState(queryParamObj);

  useEffect(() => {
    setUrl(queryParams.getUrl());
    console.log(url);
    navigate('/anime-otaku/search-results/1');
  }, [queryParams]);

  return (
    <section className='flex justify-center flex-wrap mt-24 gap-4'>
      <div className='grid grid-cols-3 items-center lg:flex lg:flex-col lg:gap-2 lg:items-start'>
        <label for='search'>Search</label>
        <Input
          id='search'
          value={queryParams.q}
          onChange={(e) =>
            setQueryParams((prevState) => {
              return {
                ...prevState,
                q: e.target.value,
              };
            })
          }
          className='py-2 px-4 h-9 col-span-2'
          placeholder='Search'
        />
      </div>

      <div className='grid grid-cols-3 items-center lg:flex lg:flex-col lg:gap-2 lg:items-start'>
        <label for='genres'>Genre</label>
        <select
          id='genres'
          value={queryParams.genres}
          onChange={(e) =>
            setQueryParams((prevState) => {
              return {
                ...prevState,
                genres: e.target.value,
              };
            })
          }
        >
          <option key={0} value=''>
            All
          </option>
          {genres.map((genre) => (
            <option
              key={genre.mal_id}
              value={genre.mal_id}
              className='text-black'
            >
              {genre.name}
            </option>
          ))}
        </select>
      </div>

      <div className='grid grid-cols-3 items-center lg:flex lg:flex-col lg:gap-2 lg:items-start'>
        <label for='status'>Status</label>
        <select
          id='status'
          value={queryParams.status}
          onChange={(e) =>
            setQueryParams((prevState) => {
              return {
                ...prevState,
                status: e.target.value,
              };
            })
          }
        >
          <option key={0} value=''>
            All
          </option>
          {statuses.map((status) => (
            <option
              key={status.label}
              value={status.value}
              className='text-black'
            >
              {status.label}
            </option>
          ))}
        </select>
      </div>

      <div className='grid grid-cols-3 items-center lg:flex lg:flex-col lg:gap-2 lg:items-start'>
        <label for='rating'>Rating</label>
        <select
          id='rating'
          value={queryParams.rating}
          onChange={(e) =>
            setQueryParams((prevState) => {
              return {
                ...prevState,
                rating: e.target.value,
              };
            })
          }
        >
          <option key={0} value='g'>
            Default
          </option>
          {ratings.map((rating) => (
            <option
              key={rating.label}
              value={rating.value}
              className='text-black'
            >
              {rating.label}
            </option>
          ))}
        </select>
      </div>

      <div className='grid grid-cols-3 items-center lg:flex lg:flex-col lg:gap-2 lg:items-start'>
        <label for='type'>Type</label>
        <select
          id='type'
          value={queryParams.type}
          onChange={(e) =>
            setQueryParams((prevState) => {
              return {
                ...prevState,
                type: e.target.value,
              };
            })
          }
        >
          <option key={0} value=''>
            Default
          </option>
          {types.map((type) => (
            <option key={type.label} value={type.value} className='text-black'>
              {type.label}
            </option>
          ))}
        </select>
      </div>
      <div className='grid grid-cols-3 items-center lg:flex lg:flex-col lg:gap-2 lg:items-start'>
        <label for='order_by'>Order by</label>
        <select
          for='order_by'
          value={queryParams.order_by}
          onChange={(e) =>
            setQueryParams((prevState) => {
              return {
                ...prevState,
                order_by: e.target.value,
              };
            })
          }
        >
          <option key={0} value=''>
            Default
          </option>
          {order_by.map((order_byItem) => (
            <option
              key={order_byItem.label}
              value={order_byItem.value}
              className='text-black'
            >
              {order_byItem.label}
            </option>
          ))}
        </select>
      </div>
    </section>
  );
};

export default Filter;
